import { render, staticRenderFns } from "./ProjectOrderTable.vue?vue&type=template&id=5a5b7216&"
import script from "./ProjectOrderTable.vue?vue&type=script&lang=ts&"
export * from "./ProjectOrderTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports